import { Typography } from '@mui/material';
import SearchBar from 'js/components/MacroInput/SearchBar';
import CardsListPageNumbersContainer from 'js/components/elements/cards/CardsListPageNumbersContainer';
import { GET_DATA_SETS_REQUEST } from 'js/constants/actionTypes';
import {
  AvailableFilterTypesByView,
  SearchFilterViews,
  SearchFilterViewsType,
} from 'js/constants/visibilityFilters';
import { MacroOptionsContextWrap } from 'js/contexts/MacroOptionsContext';
import { getConnectionOrVendorType, isDetectedDataset } from 'js/lib/ResourceUtils';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../Nexsets.module.scss';

interface SearchBannerProps {
  view: SearchFilterViewsType;
  onResourceSelected: (id: number) => void;
}

export const SearchBanner = ({ view, onResourceSelected }: SearchBannerProps) => {
  const state = useSelector((state: any) => state);
  const isLoading = useIsLoading(GET_DATA_SETS_REQUEST);
  const isClientSideSearch = view === SearchFilterViews.AVAILABLE_DATA_SETS;

  const getSourceMetaFromDataSet = (dataSetId, isDetected) => {
    // check if it is source/sink
    const {
      entities: { dataSets, sources, vendors },
      paging: { metaInfoById },
    } = state;
    const dataSet = dataSets[dataSetId];
    if (isDetected === false) {
      return null;
    }
    if (isNil(isDetected) && isDetectedDataset(dataSet) === false) {
      return null;
    }

    const sourceId = dataSet.data_source;
    const sourceEntity = sources[sourceId];

    const connectionOrVendorType = getConnectionOrVendorType(
      sourceEntity,
      vendors,
      'source_type',
      'vendor_id',
    );

    return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
  };

  return (
    <div className={styles.searchBannerContainer}>
      <div className={styles.content}>
        <Typography variant="h1">Discover Nexsets</Typography>
        <Typography variant="body2">
          Discover and integrate pre-processed data sets into your workflows - enhance efficiency by
          utilizing data that has been meticulously curated and prepared for immediate application.
        </Typography>
        <div className={styles.actions}>
          <MacroOptionsContextWrap>
            <SearchBar
              key={view}
              view={view}
              availableFilterTypes={AvailableFilterTypesByView[view]}
              isClientSideSearch={isClientSideSearch}
              getSourceMeta={getSourceMetaFromDataSet}
              onResourceSelected={onResourceSelected}
            />
          </MacroOptionsContextWrap>
          {!isClientSideSearch && <CardsListPageNumbersContainer isLoading={isLoading} />}
        </div>
      </div>
    </div>
  );
};
